import React, { useEffect } from 'react';
import { refreshScrollAnimation } from '../utils/scrollAnimation';

const Header = () => {
    useEffect(() => {
        // Refresh animations when HomeScreen mounts
        refreshScrollAnimation();
    }, []);
    useEffect(() => {
        // Initialize scripts after React component mounts
        // This ensures all DOM elements are available
        let scrollHandler = null;
        
        // Hide preloader if it exists
        const preloader = document.getElementById('preloader');
        if (preloader) {
            setTimeout(() => {
                preloader.classList.add('preloader-hidden');
                setTimeout(() => {
                    preloader.style.display = 'none';
                }, 350);
            }, 1000);
        }

        // Initialize header sticky functionality
        const navbar = document.querySelector(".navbar-area");
        if (navbar) {
            scrollHandler = () => {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const navbarElement = document.querySelector('#navbar');
                if (navbarElement) {
                    navbarElement.classList.toggle('sticky', scrollTop >= 150);
                }
            };
            window.addEventListener('scroll', scrollHandler);
        }
        
        // Cleanup function
        return () => {
            if (scrollHandler) {
                window.removeEventListener('scroll', scrollHandler);
            }
        };
    }, []);

    return (
        <>
            {/*  Preloader Start */}
            <div className="preloader-area d-flex flex-column align-items-center justify-content-center h-100" id="preloader">
                <span className="d-block stethoscope-icon"><i className="ri-stethoscope-line"></i></span>
                <span className="text-primary mt-2 fw-medium">Loading...</span>
            </div>
            {/*  Preloader End */}

            {/* Theme Switcher Start */}
            <div className="switch-theme-mode">
                <label id="switch" className="switch">
                    <input type="checkbox" onChange={() => window.toggleTheme && window.toggleTheme()} id="slider" />
                    <span className="slider round"></span>
                </label>
            </div>
            {/* Theme Switcher End */}

            {/* Custom Cursor */}
            <div className="cursor style-one"></div>
            <div className="cursor-inner style-one"></div>

            {/* Navbaar Top Start */}
            <div className="navbar-top bg-title">
                <div className="container style-one">
                    <div className="row align-items-center">
                        <div className="col-lg-6 pe-lg-0 mb-md-6">
                            <p className="fs-15 text-white text-lg-start text-center mb-0">
                                Caring Today for a Healthier Tomorrow and Forever
                                <a href="doctors-list.html" className="ms-xl-3 ms-2 text-white fw-medium link-hover-white">
                                    Find A Doctor
                                    <img src="/assets/img/icons/right-arrow-white.svg" alt="Icon" />
                                </a>
                            </p>
                        </div>
                        <div className="col-lg-6">
                            <div className="navbar-top-options d-flex flex-wrap align-items-center justify-content-lg-end justify-content-center">
                                <div className="navbar-option-item position-relative">
                                    <a href="online-payment.html" className="fs-15 text-white link-hover-white">Pay Your Bill</a>
                                </div>
                                <div className="navbar-option-item position-relative">
                                    <a href="pricing-plan.html" className="fs-15 text-white link-hover-white">Service Price List</a>
                                </div>
                                <div className="navbar-option-item position-relative">
                                    <div className="language-selector position-relative d-inline-block">
                                        <div className="selected-language d-flex align-items-center" id="selected-language">
                                            <span className="flag-container rounded-circle">
                                                <img src="/assets/img/dashboard/flag/uk.png" alt="US Flag" className="rounded-circle" />
                                            </span>
                                            <span className="lang-name fs-14 text-white">English</span>
                                        </div>
                                        <div className="dropdown" id="dropdown">
                                            <div className="dropdown-item" data-lang="en" data-flag="/assets/img/dashboard/flag/uk.png">
                                                <span className="flag-container rounded-circle">
                                                    <img src="/assets/img/dashboard/flag/uk.png" alt="US Flag" className="rounded-circle" />
                                                </span>
                                                <span className="lang-name fs-14 text-title">English</span>
                                            </div>
                                            <div className="dropdown-item" data-lang="fr" data-flag="/assets/img/dashboard/flag/france.png">
                                                <span className="flag-container rounded-circle">
                                                    <img src="/assets/img/dashboard/flag/france.png" alt="US Flag" className="rounded-circle" />
                                                </span>
                                                <span className="lang-name fs-14 text-title">French</span>
                                            </div>
                                            <div className="dropdown-item" data-lang="ar" data-flag="/assets/img/dashboard/flag/uae.png">
                                                <span className="flag-container rounded-circle">
                                                    <img src="/assets/img/dashboard/flag/uae.png" alt="French Flag" className="rounded-circle" />
                                                </span>
                                                <span className="lang-name fs-14 text-title">Arabic</span>
                                            </div>
                                            <div className="dropdown-item" data-lang="ch" data-flag="/assets/img/dashboard/flag/china.png">
                                                <span className="flag-container rounded-circle">
                                                    <img src="/assets/img/dashboard/flag/china.png" alt="Spanish Flag" className="rounded-circle" />
                                                </span>
                                                <span className="lang-name fs-14 text-title">Chinese</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Navbaar Top End */}

            {/* Navbar Center Start */}
            <div className="navbar-center style-one d-none d-lg-block">
                <div className="container style-one">
                    <div className="row align-items-center">
                        <div className="col-xl-3 col-lg-2 col-5">
                            <a href="index.html" className="logo">
                                <img src="/assets/img/logo.png" alt="Logo" className="logo-light" />
                                <img src="/assets/img/logo-white.png" alt="Logo" className="logo-dark" />
                            </a>
                        </div>
                        <div className="col-xl-9 col-lg-10 col-7">
                            <div className="contact-card-wrap style-two d-none d-lg-flex flex-wrap align-items-center justify-content-lg-end">
                                <div className="contact-card d-flex flex-wrap align-items-center">
                                    <div className="contact-icon d-flex flex-column align-items-center justify-content-center rounded-circle bg-white transition">
                                        <img src="/assets/img/icons/phone-blue.svg" alt="Icon" className="transition" />
                                    </div>
                                    <div className="contact-info">
                                        <span className="d-block fs-15 fs-xx-14">Emergency Line</span>
                                        <a href="tel:123456789043" className="d-inline-block font-secondary fw-semibold text-title fs-xx-14 hover-text-secondary">+1 (234) 567 890 43</a>
                                    </div>
                                </div>

                                <div className="contact-card d-flex flex-wrap align-items-center">
                                    <div className="contact-icon d-flex flex-column align-items-center justify-content-center rounded-circle bg-white transition">
                                        <img src="/assets/img/icons/mail-blue.svg" alt="Icon" className="transition" />
                                    </div>
                                    <div className="contact-info">
                                        <span className="d-block fs-15 fs-xx-14">Support Email</span>
                                        <a href="#" className="d-inline-block font-secondary fw-semibold text-title fs-xx-14 hover-text-secondary">[email protected]</a>
                                    </div>
                                </div>

                                <div className="contact-card d-flex flex-wrap align-items-center">
                                    <div className="contact-icon d-flex flex-column align-items-center justify-content-center rounded-circle bg-white transition">
                                        <img src="/assets/img/icons/pin-blue.svg" alt="Icon" className="transition" />
                                    </div>
                                    <div className="contact-info">
                                        <span className="d-block fs-15 fs-xx-14">Visit Us On</span>
                                        <p className="font-secondary fw-semibold text-title fs-xx-14 mb-0">245 14h Street, Torento, Canada</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Navbar Center End */}

            {/* Navbar Area Start */}
            <div className="navbar-area style-one" id="navbar">
                <div className="container style-one">
                    <div className="navbar-wrapper d-flex justify-content-between align-items-center p-0">
                        <a href="index.html" className="logo d-lg-none">
                            <img src="/assets/img/logo.png" alt="Logo" className="logo-light" />
                            <img src="/assets/img/logo-white.png" alt="Logo" className="logo-dark" />
                        </a>
                        <div className="menu-area me-auto">
                            <div className="overlay"></div>
                            <nav className="menu">
                                <div className="menu-mobile-header">
                                    <button type="button" className="menu-mobile-arrow bg-transparent border-0"><i className="ri-arrow-left-s-line"></i></button>
                                    <button type="button" className="menu-mobile-close bg-transparent border-0"><i className="ri-close-line"></i></button>
                                </div>
                                <ul className="menu-section p-0 mb-0">
                                    <li className="menu-item-has-children">
                                        <a href="javascript:void(0)">Home</a>
                                        <ul className="menu-subs menu-column-1">
                                            <li><a href="index.html">Home Demo One</a></li>
                                            <li><a href="index-2.html">Home Demo Two</a></li>
                                            <li><a href="index-3.html">Home Demo Three</a></li>
                                        </ul>
                                    </li>
                                    <li><a href="about.html">About</a></li>
                                    <li className="menu-item-has-children">
                                        <a href="javascript:void(0)" className="active">Pages</a>
                                        <ul className="menu-subs menu-column-1">
                                            <li className="menu-item-has-children">
                                                <a href="javascript:void(0)">Dashboard</a>
                                                <ul className="menu-subs menu-column-1">
                                                    <li className="menu-item-has-children">
                                                        <a href="javascript:void(0)">Doctors Dashboard</a>
                                                        <ul className="menu-subs menu-column-1">
                                                            <li><a href="db-doctors-dashboard.html">Doctors Dashboard</a></li>
                                                            <li><a href="db-doctors-list.html">Doctors List</a></li>
                                                            <li><a href="db-doctors-card.html">Doctors Card</a></li>
                                                            <li><a href="db-doctor-profile.html">Doctors Profile</a></li>
                                                            <li><a href="db-add-doctor.html">Add Doctor</a></li>
                                                            <li><a href="db-edit-doctor.html">Edit Doctor</a></li>
                                                        </ul>
                                                    </li>
                                                    <li className="menu-item-has-children">
                                                        <a href="javascript:void(0)">Patient Dashboard</a>
                                                        <ul className="menu-subs menu-column-1">
                                                            <li><a href="db-patients-dashboard.html">Patient Dashboard</a></li>
                                                            <li><a href="db-patients-list.html">Patient List</a></li>
                                                            <li><a href="db-add-patient.html">Add Patient</a></li>
                                                            <li><a href="db-edit-patient-details.html">Edit Patient Details</a></li>
                                                        </ul>
                                                    </li>
                                                    <li className="menu-item-has-children">
                                                        <a href="javascript:void(0)">Hospital Dashboard</a>
                                                        <ul className="menu-subs menu-column-1">
                                                            <li><a href="db-hospital-dashboard.html">Hospital Dashboard</a></li>
                                                            <li><a href="db-doctors.html">Doctors</a></li>
                                                            <li><a href="db-employees.html">Employees Card</a></li>
                                                            <li><a href="db-attendance.html">Attendance</a></li>
                                                            <li><a href="db-leaves.html">Leaves</a></li>
                                                            <li><a href="db-salary.html">Salary</a></li>
                                                            <li><a href="db-department.html">Department</a></li>
                                                            <li><a href="db-services.html">Services</a></li>
                                                            <li><a href="db-role-access.html">Role Access</a></li>
                                                            <li><a href="db-holidays.html">Holidays</a></li>
                                                            <li><a href="db-my-activities.html">My Activities</a></li>
                                                        </ul>
                                                    </li>
                                                    <li className="menu-item-has-children">
                                                        <a href="javascript:void(0)">Appointments</a>
                                                        <ul className="menu-subs menu-column-1">
                                                            <li><a href="db-appointments.html">Appointments</a></li>
                                                            <li><a href="db-appointment-list.html">Appointment List</a></li>
                                                            <li><a href="db-book-appointment.html">Book Appointment</a></li>
                                                            <li><a href="db-edit-appointment.html">Edit Appointment</a></li>
                                                        </ul>
                                                    </li>
                                                    <li><a href="db-chat.html">Chat</a></li>
                                                    <li><a href="db-notification.html">Notification</a></li>
                                                </ul>
                                            </li>
                                            <li><a href="availability-checker.html" className="active">Availability Checker</a></li>
                                            <li><a href="appointment-booking.html">Appointment Booking</a></li>
                                            <li><a href="top-specialization.html">Top Specialization</a></li>
                                            <li><a href="top-specialization-details.html">Top Specialization Details</a></li>
                                            <li><a href="online-consultation-telemedicine.html">Online Consultation &amp; Telemedicine</a></li>
                                            <li><a href="billing-insurance.html">Billing &amp; Insurance</a></li>
                                            <li><a href="online-payment.html">Online Payment</a></li>
                                            <li><a href="pricing-plan.html">Pricing Plan</a></li>
                                            <li><a href="faq.html">FAQ</a></li>
                                            <li><a href="testimonials.html">Testimonials</a></li>
                                            <li><a href="register.html">Register</a></li>
                                            <li><a href="terms-conditions.html">Terms &amp; Conditions</a></li>
                                            <li><a href="privacy-policy.html">Privacy Policy</a></li>
                                            <li><a href="error-404.html">Error 404</a></li>
                                        </ul>
                                    </li>
                                    <li className="menu-item-has-children">
                                        <a href="javascript:void(0)">Doctors</a>
                                        <ul className="menu-subs menu-column-1">
                                            <li><a href="doctors-search.html">Doctors Search</a></li>
                                            <li><a href="doctors-list.html">Doctors List</a></li>
                                            <li><a href="doctor-details.html">Doctor Details</a></li>
                                            <li><a href="doctor-reviews-location-with-map.html">Doctor Reviews &amp; Location With Map</a></li>
                                            <li><a href="top-doctors.html">Top Doctors</a></li>
                                            <li><a href="doctor-account.html">Doctor Account</a></li>
                                        </ul>
                                    </li>
                                    <li className="menu-item-has-children">
                                        <a href="javascript:void(0)">Hospitals</a>
                                        <ul className="menu-subs menu-column-1">
                                            <li><a href="hospitals-search.html">Hospitals Search</a></li>
                                            <li><a href="hospitals-list.html">Hospitals List</a></li>
                                            <li><a href="hospital-details.html">Hospital Details</a></li>
                                            <li><a href="hospital-reviews-location-with-map.html">Hospital Reviews &amp; Location With Map</a></li>
                                            <li><a href="patient-account.html">Patient Account</a></li>
                                        </ul>
                                    </li>
                                    <li className="menu-item-has-children">
                                        <a href="javascript:void(0)">Blog</a>
                                        <ul className="menu-subs menu-column-1">
                                            <li className="menu-item-has-children">
                                                <a href="javascript:void(0)">Blog Layout</a>
                                                <ul className="menu-subs menu-column-1">
                                                    <li><a href="blog-left-sidebar.html">Blog Left Sidebar</a></li>
                                                    <li><a href="blog-right-sidebar.html">Blog Right Sidebar</a></li>
                                                    <li><a href="blog-grid.html">Blog Grid</a></li>
                                                </ul>
                                            </li>
                                            <li className="menu-item-has-children">
                                                <a href="javascript:void(0)">Blog Details Layout</a>
                                                <ul className="menu-subs menu-column-1">
                                                    <li><a href="blog-details-left-sidebar.html">Blog Details Left Sidebar</a></li>
                                                    <li><a href="blog-details-right-sidebar.html">Blog Details Right Sidebar</a></li>
                                                    <li><a href="blog-details-no-sidebar.html">Blog Details No Sidebar</a></li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                    <li><a href="contact.html">Contact</a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="other-options d-flex flex-wrap align-items-center justify-content-end">
                            <div className="option-item d-lg-none">
                                <div className="contact-card-btn">
                                    <button className="dropdown-toggle d-flex align-items-center position-relative bg-transparent border-0 ms-auto transition" type="button" data-bs-toggle="dropdown" aria-expanded="true">
                                        <img src="/assets/img/dashboard/icons/dot.svg" alt="Dot Icon" className="action-btn" />
                                    </button>
                                    <div className="dropdown-menu top-1 border-0 round-5">
                                        <div className="contact-card-wrap style-two d-flex flex-wrap">
                                            <div className="contact-card d-flex flex-wrap align-items-center">
                                                <div className="contact-icon d-flex flex-column align-items-center justify-content-center rounded-circle bg-ash transition">
                                                    <img src="/assets/img/icons/phone-blue.svg" alt="Icon" className="transition" />
                                                </div>
                                                <div className="contact-info">
                                                    <span className="d-block fs-15 fs-xx-14">Emergency Line</span>
                                                    <a href="tel:123456789043" className="d-inline-block font-secondary fw-semibold text-title fs-xx-14 hover-text-secondary">+1 (234) 567 890 43</a>
                                                </div>
                                            </div>
                                            <div className="contact-card d-flex flex-wrap align-items-center">
                                                <div className="contact-icon d-flex flex-column align-items-center justify-content-center rounded-circle bg-ash transition">
                                                    <img src="/assets/img/icons/mail-blue.svg" alt="Icon" className="transition" />
                                                </div>
                                                <div className="contact-info">
                                                    <span className="d-block fs-15 fs-xx-14">Support Email</span>
                                                    <a href="/cdn-cgi/l/email-protection#d8abada8a8b7aaac98b0b1b6acb7b6f6bbb7b5" className="d-inline-block font-secondary fw-semibold text-title fs-xx-14 hover-text-secondary">
                                                        <span className="__cf_email__" data-cfemail="7d0e080d0d120f093d151413091213531e1210">[email&#160;protected]</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="contact-card d-flex flex-wrap align-items-center">
                                                <div className="contact-icon d-flex flex-column align-items-center justify-content-center rounded-circle bg-ash transition">
                                                    <img src="/assets/img/icons/pin-blue.svg" alt="Icon" className="transition" />
                                                </div>
                                                <div className="contact-info">
                                                    <span className="d-block fs-15 fs-xx-14">Visit Us On</span>
                                                    <p className="font-secondary fw-semibold text-title fs-xx-14 mb-0">245 14h Street, Torento, Canada</p>
                                                </div>
                                            </div>
                                        </div>
                                        <a href="appointment-booking.html" className="btn style-two font-secondary fw-semibold position-relative z-1 round-10">
                                            <span>Make An Appointment
                                                <img src="/assets/img/icons/right-arrow-white.svg" alt="Icon" className="transition icon-left" />
                                            </span>
                                            <img src="/assets/img/icons/right-arrow-white.svg" alt="Icon" className="transition icon-right" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="option-item">
                                <div className="currency-selector position-relative">
                                    <img src="/assets/img/icons/dollar.svg" alt="Icon" />
                                    <select className="text-title outline-0 fw-semibold bg-transparent border-0">
                                        <option value="1">USD</option>
                                        <option value="2">GBP</option>
                                        <option value="3">YEN</option>
                                    </select>
                                </div>
                            </div>
                            <div className="option-item d-lg-inline-block">
                                <a href="register.html" className="header-link font-secondary fw-semibold position-relative d-inline-block text-title hover-text-secondary link-hover-secondary transition">
                                    <i className="ri-account-circle-line"></i>
                                    <span className="d-none d-lg-inline-block">Login/Register</span>
                                </a>
                            </div>
                            <div className="option-item d-lg-none me-0">
                                <button type="button" className="menu-mobile-trigger">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </button>
                            </div>
                            <div className="option-item d-none d-lg-block">
                                <a href="appointment-booking.html" className="btn style-two font-secondary fw-semibold position-relative z-1 round-10">
                                    <span>Make An Appointment
                                        <img src="/assets/img/icons/right-arrow-white.svg" alt="Icon" className="transition icon-left" />
                                    </span>
                                    <img src="/assets/img/icons/right-arrow-white.svg" alt="Icon" className="transition icon-right" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                {/* KEEP your full navbar code same (no deletions) */}
            </>
            );
};

            export default Header;
